import React, { FC, useContext, useEffect } from 'react'
import { useRouter } from 'next/router'
import { RegistrationForm0 } from '../forms/RegistrationForm0/RegistrationForm0'
import { RegistrationForm1 } from '../forms/RegistrationForm1/RegistrationForm1'
import { RegistrationForm5 } from '../forms/RegistrationForm5/RegistrationForm5'
import { RegistrationForm7 } from '../forms/RegistrationForm7/RegistrationForm7'
import { RegistrationForm12 } from '../forms/RegistrationForm12/RegistrationForm12'
import { RegistrationForm13 } from '../forms/RegistrationForm13/RegistrationForm13'
import { RegistrationForm14 } from '../forms/RegistrationForm14/RegistrationForm14'
import { RegistrationForm15 } from '../forms/RegistrationForm15/RegistrationForm15'
import { RegistrationForm16 } from '../forms/RegistrationForm16/RegistrationForm16'
import { SocialNetworks } from '../../../../emun/social'
import { Languages } from '../../../../interfaces/common'
import { LocaleContext } from '../../../LocaleContext/LocaleContext'
import { getQueryParam } from '../../../../utils/getQueryParam'
import { RegistrationForm17 } from '../forms/RegistrationForm17/RegistrationForm17'
import { UserContext } from '../../../UserContext/UserContext'
import { useEnv } from '../../../../utils/useEnv'
import { lkHosts } from '../../../../config/hosts/lkHosts'

type RouterProps = {
  onSocialAuth(socialNetwork: SocialNetworks, callbackUrl?: string): void
}

export const RegistrationFormRouter: FC<RouterProps> = ({ onSocialAuth }) => {
  const { query } = useRouter()
  const { locale } = React.useContext(LocaleContext)
  const form = getQueryParam(query, 'form')
  const { user } = useContext(UserContext)
  const router = useRouter()
  const deployEnv = useEnv()
  const profileUrl = lkHosts[deployEnv][locale]

  useEffect(() => {
    if (user) {
      router.push(profileUrl)
    }
  }, [user, router, profileUrl])

  switch (form) {
    case '1':
      return <RegistrationForm1 onSocialAuth={onSocialAuth} />
    case '5':
      return <RegistrationForm5 onSocialAuth={onSocialAuth} />
    case '7':
      return <RegistrationForm7 onSocialAuth={onSocialAuth} />
    case '12':
      return <RegistrationForm12 onSocialAuth={onSocialAuth} />
    case '13':
      return <RegistrationForm13 onSocialAuth={onSocialAuth} />
    case '14':
      return <RegistrationForm14 onSocialAuth={onSocialAuth} />
    case '15':
      if (locale === Languages.RU) {
        return <RegistrationForm15 onSocialAuth={onSocialAuth} />
      }

      return <RegistrationForm0 onSocialAuth={onSocialAuth} />
    case '16':
      return <RegistrationForm16 />
    case '17':
      return <RegistrationForm17 onSocialAuth={onSocialAuth} />
    default:
      return <RegistrationForm0 onSocialAuth={onSocialAuth} />
  }
}

RegistrationFormRouter.displayName = 'RegistrationFormRouter'
